import { createContext } from 'react';
import { BooleanEntryStore } from '../../store';

export const BooleanEntryContext = createContext<BooleanEntryStore | null>(
  null
);
